/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable, Injector } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { environment } from '@env/environment';

import { Observable } from 'rxjs';

import { AuthService } from '../services/auth.service';

// import { AuthService } from '@app/core/services/auth.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private secureRoutes = [
    environment.services.assetApi,
    environment.services.catalogApi,
    environment.services.idpApi,
    environment.services.notificationsApi,
    environment.services.notificationsHub,
    environment.services.oneHubApi,
    environment.services.portalApi,
    environment.services.referenceApi,
    environment.services.autocareApi,
    environment.services.searchApi,
    environment.services.autocareReferenceApi,
  ];

  constructor(private injector: Injector) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Ensure we send the token only to routes which are secured
    if (!this.secureRoutes.find((x) => req.url.startsWith(x))) {
      return next.handle(req);
    }

    // Avoid adding the token for the OAuth2 endpoints
    if (req.url.includes('hub/oauth2')) {
      return next.handle(req);
    }

    // Lazy injection of AuthService to avoid circular dependency
    const authService = this.injector.get(AuthService);

    // Get the access token from the auth service
    // const idToken = authService.getIdToken();
    const idToken = authService.getAccessToken();

    // If there's no token or user is not authenticated, proceed without modification
    if (!idToken || !authService.isAuthenticated) {
      return next.handle(req);
    }

    // Clone the request and add the Authorization header
    const authReq = req.clone({
      setHeaders: {
        Authorization: `Bearer ${idToken}`,
      },
    });

    return next.handle(authReq);
  }
}
